module.exports = __webpack_public_path__ + "assets/img/selected.164164bd.svg";